import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Organization } from '../model/Organization';
import { SessionHelper } from "@src/app/helpers/sessionHelper";
import { PersonOrganization } from '@src/app/components/footer/model/personorganization';
import { environment } from '@src/environments/environment';




@Injectable({
  providedIn: 'root'
})
export class OrgeditService {

  constructor(
    private http:HttpClient
    ) { }

  getOrg(orgId:string){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json' 
      })
    }
    return this.http.get<any>(environment.apiUrl+'/organization/'+orgId,httpOptions)
  }
  updateOrg(org:Organization){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json' 
      })
    }
    return this.http.put<any>(environment.apiUrl+'/organization/'+org.organizationId,JSON.stringify(org),httpOptions)
  }
  getPersonOrgList(personId:string){

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    var urlCombo = environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/person/'+personId+'/organization/mylist';


    return this.http.get<PersonOrganization[]>(urlCombo,httpOptions);
  }
}
